import { TranslatableText } from '@dreryk/react-common';
import {
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalMaxHeight,
   ModalWidth,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';

import { VideoConsultationPatientContactUpdateShowModalEventInterceptor } from '~libs.desktop.video-consultation';

import { AppointmentUpdateForm, AppointmentUpdateFormController } from './AppointmentUpdateForm';
import { AppointmentUpdateFormLoader } from './AppointmentUpdateForm.loader';
import { formInitializer } from './AppointmentUpdateModal.utils';

type AppointmentUpdateModalConfirmButtonRenderer = (
   renderProps: Pick<AppointmentUpdateFormController, 'handleSubmit'>
) => JSX.Element;

type AppointmentUpdateModalProps = {
   readonly onClose: VoidFunction;
   readonly appointmentId: number;
   readonly title: TranslatableText;
   readonly confirmButton: AppointmentUpdateModalConfirmButtonRenderer;
};

// eslint-disable-next-line max-lines-per-function
export const AppointmentUpdateModal = (props: AppointmentUpdateModalProps): JSX.Element => {
   return (
      <Modal testId={'updateAppointmentModal'} title={props.title} width={ModalWidth.WIDE} height={ModalMaxHeight.TALL}>
         <AppointmentUpdateFormLoader appointmentId={props.appointmentId}>
            {({
               appointmentDetails,
               practitioners,
               healthcareProviderLocations,
               patient,
               onlinePaymentsIntegrationExists,
            }) => (
               <AppointmentUpdateForm
                  appointmentId={appointmentDetails.id}
                  initializer={formInitializer(appointmentDetails, healthcareProviderLocations, patient)}
                  practitioners={practitioners}
                  healthcareProviderLocations={healthcareProviderLocations}
                  patientCreateAllowed
                  onlinePaymentsIntegrationExists={onlinePaymentsIntegrationExists}
               >
                  {({ getValue, handleSubmit, formState, trigger }) => {
                     const patientId = getValue('patient')?.id ?? null;
                     const videoConsultationEnabled = Boolean(getValue('videoConsultation'));

                     return (
                        <>
                           <ValidateFormEventInterceptor trigger={trigger} silent>
                              <VideoConsultationPatientContactUpdateShowModalEventInterceptor
                                 patientId={patientId}
                                 shouldShowModal={videoConsultationEnabled}
                              >
                                 {props.confirmButton({
                                    handleSubmit: handleSubmit,
                                 })}
                              </VideoConsultationPatientContactUpdateShowModalEventInterceptor>
                           </ValidateFormEventInterceptor>
                           <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                           <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                        </>
                     );
                  }}
               </AppointmentUpdateForm>
            )}
         </AppointmentUpdateFormLoader>
      </Modal>
   );
};
